export const formatPhoneNum = mobile => {
    const arr = mobile.split('');

    arr.splice(3, 4, '****');

    return arr.join('');
};

export const formatMail = mail => {
    if (!mail) {
        return mail;
    }
    const arr = mail.split('@');

    let first = arr[0].split('');
    const second = arr[1].split('.');

    first = first.map((item, index) => {
        return index <= 1 ? item : '*';
    });

    const domain = second[0].split('').map((item, index) => {
        return index === second[0].split('').length - 1 ? item : '*';
    });

    return `${first.join('')}@${domain.join('')}.${second[1]}`;
};
